import { FieldErrors } from "react-hook-form";

import { IAccumulatedFieldError } from "./errors-display.models";

export const accumulateFieldErrors = (
  formErrors: FieldErrors,
  parentPath = "",
): IAccumulatedFieldError[] => {
  let accumulatedErrors: IAccumulatedFieldError[] = [];

  Object.keys(formErrors).forEach(key => {
    const error = formErrors[key];
    const currentPath = parentPath ? `${parentPath}.${key}` : key;

    if (!error || typeof error !== "object") {
      return;
    }

    if (error.message) {
      accumulatedErrors.push({
        path: currentPath,
        message: error.message as string,
      });
      return;
    }

    accumulatedErrors = accumulatedErrors.concat(
      accumulateFieldErrors(error as FieldErrors, currentPath),
    );
  });

  return accumulatedErrors;
};

export const extractFieldNameFromPath = (path: string): string => {
  if (!path?.includes(".")) {
    return path;
  }

  return path.split(".").at(-1) || "";
};
